import React from 'react';

import styled from 'styled-components';
import { TextColor, TextKind, textStyleFrom } from '../Text';
import ReadMore from './ReadMore';

interface BodySProps {
  children?: React.ReactNode;
  onToggleClick?: (isExpanded: boolean, event?: React.MouseEvent) => void;
  lines?: number;
  truncationWidth?: number;
  className?: string;
}

const StyledReadMoreBodyS = styled(ReadMore)({
  ...textStyleFrom(TextKind.BodyS, TextColor.Primary),
});

const BodyS: React.FC<BodySProps> = ({
  children,
  onToggleClick,
  lines,
  truncationWidth,
}) => (
  <StyledReadMoreBodyS
    less="See Less"
    more="See More"
    onToggleClick={onToggleClick}
    lines={lines}
    truncationWidth={truncationWidth}
  >
    {children}
  </StyledReadMoreBodyS>
);

export const InlineShowMore = {
  BodyS,
};
